import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import Header from '../common/header-simple';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  return (
    <>
      <Header />

      <Container component="main">
        <Stack
          sx={{
            py: { xs: 4, sm: 5 },
            m: 'auto',
            width: '100%',
            maxWidth: { xs: '100%', sm: 720, md: 960, lg: 1120 },
            minHeight: '100vh',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
